/**
 * Created by mady on 11-0-2017.
 * Component: Data Hierarchy Spot
 * Variations:
 * data-list-search open-orders
 */

(function ($, DGS, moment) {
  var dictionary = {
      B2B: {
        OrderSearchFor: 'Search for an order',
        HelpAccept: 'Got it, thank you!',
        OrderSearchPlaceholder: 'Search orders by patient name, serial number or order number',
        ProductOrderSearchPlaceholder: 'Search product orders by member name, PA Number or order number',
        ServiceOrderSearchPlaceholder: 'Search service orders by member name, serial number, PA Number or order number',
        WarrantyStatusSearchPlaceholder: 'Search warranties by member name, serial number, PA Number or order number',
        WarrantySearchFor: 'Search for a warranties',
        WarrantySearchPlaceholder: 'Search instruments by patient name, serial number, device or order number',
        InstrumentsSearchFor: 'Search for an instruments',
        InstrumentsSearchPlaceholder: 'Search instruments by patient name, serial number, device or order number',
        AdvancedSearch: 'Advanced Search',
        OrderNumberLabel: 'Order Number',
        EgNumber: 'eg. 6647805',
        OrderPatientNameLabel: 'Patient Name',
        OrderDateSearch: 'Apply Order Date',
        OrderCategorySearch: 'Apply Category',
        EgName: 'eg. John Doe',
        ProductCategory: 'Device',
        Model: 'Model',
        Style: 'Style',
        OrderDateLabel: 'Order Date',
        SerialNumberLabel: 'Serial number',
        SerialNumberSecondDeviceLabel: 'Serial number second device',
        EgSerialFirstDevice: 'First device',
        EgSerialSecondDevice: 'Second device',
        ShowOrders: 'Show orders',
        All: 'All',
        CreditMemoSearchFor: 'Search for a credit memo',
        CreditMemoSearchPlaceholder: 'Search orders by patient name, serial number or order number',
        CreditMemoNumberLabel: 'Credit Memo Number',
        CreditMemoNumberPlaceholder: 'eg. 6647805',
        CreditMemoStatusLabel: 'Status',
        CreditMemoStatusPlaceholder: 'eg. Open',
        CreditMemoDateLabel: 'Credit Memo Date',
        ShowCreditMemos: 'Show Credit Memos',
        InvoiceSearchFor: 'Search for an invoice',
        InvoiceSearchPlaceholder: 'Search invoices by patient name, serial number  order number or invoice number',
        InvoiceNumberLabel: 'Invoice Number',
        InvoiceNumberPlaceholder: 'eg. 6647805',
        InvoiceDateLabel: 'Invoice Date',
        ShowInvoices: 'Show Invoices',
        Dateformat: '{0:"YYYY-MM-DD"}',
        EgSerialNo: 'eg. A09754078',
        WarrantyPatientNameLabel: 'Patient Name',
        ExpirationDateLabel: 'Expiration Date',
        ShowWarranties: 'Show Warranties',
        EmptyDatepickerText: 'None',
        DisclaimerProductOrders: '*Click the Service Orders tab below to search for service orders.',
        DisclaimerServiceOrders: '*Click the Product Orders tab below to search for product orders.'
      }
    },
    datepickerNoRangeStyleVariation = 'allow-no-range',
    runAdvancedQuery = function runAdvancedQuery($dataListSearchSpot, endpoint) {
      var $this = $dataListSearchSpot,
        $queryField = $('.data-list-search-spot__query', $dataListSearchSpot),
        queryString = $queryField.val(),
        filterObject = {},
        searchObject = {},
        datePicker = $('.date-list-search-spot--date-picker', $this),
        fromDate = datePicker.customDatePickerFrom() ? datePicker.customDatePickerFrom() : new Date(0),
        // This is 0 milliseconds since unix time 1970
        toDate = datePicker.customDatePickerTo() ? datePicker.customDatePickerTo() : new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
        // This is one year from now
        c = 0,
        searchHashes = [];

      // RUN THROUGH ALL data-list-search-spot__adv-search-input
      // ADD VALUE TO FILTER IF VALUE IS NOT EMPTY
      $('.data-list-search-spot__adv-search-input', $this).each(function () {
        var $this = $(this),
          re = /(field-[a-zA-Z]+)/,
          m,
          field,
          value = $this.val() ? $this.val().trim() : '';
        if ((m = re.exec($this.prop('class'))) !== null) {
          if (m.index === re.lastIndex) {
            re.lastIndex++;
          }
          field = m[0].substr(6);
        }
        if (field && value != '' && (field != 'categories' || value != 'All') && (field != 'models' || value != 'All') && (field != 'styles' || value != 'All')) {
          filterObject[field] = createQueryForIndex(field, value);
          searchObject[field] = createQueryForIndexNoDate(value);
          searchHashes.push("".concat(field, ":").concat(value));
        }
      });
      var filterWithNoQueryNoHash = function filterWithNoQueryNoHash() {
          if ($('.searchThroughDate')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'text=' + ' AND ' + 'orderDateUtc*');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'text=');
          }
        },
        filterWithNoQueryButHash = function filterWithNoQueryButHash() {
          if ($('.searchThroughDate')[0]) {
            if ($('.reset-all')[0]) {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'text=' + ' AND ' + 'orderDateUtc*');
            } else {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(Object.keys(filterObject).map(function (f) {
                return filterObject[f];
              }).join(' AND '), " AND ") + 'orderDateUtc*');
            }
          } else if ($('.reset-all')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'text=');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(Object.keys(filterObject).map(function (f) {
              return filterObject[f];
            }).join(' AND ')));
          }
        },
        filterWithQueryNoHash = function filterWithQueryNoHash() {
          if ($('.searchThroughDate')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*") + ' AND ' + 'orderDateUtc*');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*"));
          }
        },
        filterWithQueryAndHash = function filterWithQueryAndHash() {
          if ($('.searchThroughDate')[0]) {
            if ($('.reset-all')[0]) {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*") + ' AND ' + 'orderDateUtc*');
            } else {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*") + " AND ".concat(Object.keys(filterObject).map(function (f) {
                return filterObject[f];
              }).join(' AND '), " AND ") + 'orderDateUtc*');
            }
          } else if ($('.reset-all')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*"));
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*") + " AND ".concat(Object.keys(filterObject).map(function (f) {
              return filterObject[f];
            }).join(' AND ')));
          }
        },
        filterWithNoQueryNoHashInst = function filterWithNoQueryNoHashInst() {
          if ($('.checkboxChecked')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'text=' + "isWarrantyExpiring eq '1' OR isWarrantyExpiring eq '2'");
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'parameter=');
          }
        },
        filterWithNoQueryButHashInst = function filterWithNoQueryButHashInst() {
          if ($('.checkboxChecked')[0]) {
            if ($('.reset-all')[0]) {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'text=' + "isWarrantyExpiring eq '1' OR isWarrantyExpiring eq '2'");
            } else {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, endpoint, fromDate, toDate, searchObject, 'and', 'text=' + "isWarrantyExpiring eq '1' OR isWarrantyExpiring eq '2'");
            }
          } else if ($('.reset-all')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'parameter=');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, endpoint, fromDate, toDate, searchObject);
          }
        },
        filterWithQueryNoHashInst = function filterWithQueryNoHashInst() {
          if ($('.checkboxChecked')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*") + ' AND ' + '(isWarrantyExpiring eq \'1\' OR isWarrantyExpiring eq \'2\')');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*"));
          }
        },
        filterWithQueryAndHashInst = function filterWithQueryAndHashInst() {
          if ($('.checkboxChecked')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, endpoint, fromDate, toDate, searchObject, 'and', "text=".concat(queryString.trim(), "*") + ' AND ' + '(isWarrantyExpiring eq \'1\' OR isWarrantyExpiring eq \'2\')');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, endpoint, fromDate, toDate, searchObject, 'and', "text=".concat(queryString.trim(), "*"));
          }
        };
      DGS.setLocationHash(searchHashes.join('/'));
      if (window.location.href.indexOf('instrument-history') > -1) {
        if ($('.reset-all-options')[0]) {
          DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'parameter=');
        } else if (queryString == '') {
          searchHashes == '' ? filterWithNoQueryNoHashInst() : filterWithNoQueryButHashInst();
        } else {
          searchHashes == '' ? filterWithQueryNoHashInst() : filterWithQueryAndHashInst();
        }
      } else if ($dataListSearchSpot.hasClass('service-orders') || $dataListSearchSpot.hasClass('product-orders') || $dataListSearchSpot.hasClass('warranty-status')) {
        if ($('.reset-all-options')[0]) {
          DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', 'text=');
        } else if (queryString == '') {
          searchHashes == '' ? filterWithNoQueryNoHash() : filterWithNoQueryButHash();
        } else {
          searchHashes == '' ? filterWithQueryNoHash() : filterWithQueryAndHash();
        }
      } else {
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, endpoint, fromDate, toDate, {}, 'and', "text=".concat(Object.keys(filterObject).map(function (f) {
          return filterObject[f];
        }).join(' AND ')));
      }
    },
    runBasicQuery = function runBasicQuery($dataListSearchSpot, config) {
      var dateFormat = dictionary.B2B.Dateformat.replace('{0:', '').replace('}', ''),
        $queryField = $('.data-list-search-spot__query', $dataListSearchSpot),
        queryString = $queryField.val(),
        dateFormatString = dateFormat.toUpperCase(),
        dateMoment = moment.utc(queryString, dateFormatString, true),
        queryDate = dateMoment.isValid() ? dateMoment.toDate() : null,
        datePicker = $('.date-list-search-spot--date-picker', $this),
        // from and to date from advance search
        fromDate = datePicker.customDatePickerFrom() ? datePicker.customDatePickerFrom() : new Date(moment().subtract(60, 'days').calendar()),
        // This is 60 days from today 
        toDate = datePicker.customDatePickerTo() ? datePicker.customDatePickerTo() : new Date(),
        // This is today
        $this = $dataListSearchSpot,
        filterObject = {},
        searchObject = {},
        c = 0,
        searchHashes = [],
        textSearch = '';
      $('.data-list-search-spot__adv-search-input', $this).each(function () {
        var $this = $(this),
          re = /(field-[a-zA-Z]+)/,
          m,
          field,
          value = $this.val() ? $this.val().trim() : '';
        if ((m = re.exec($this.prop('class'))) !== null) {
          if (m.index === re.lastIndex) {
            re.lastIndex++;
          }
          field = m[0].substr(6);
        }
        if (field && value != '' && (field != 'categories' || value != 'All') && (field != 'models' || value != 'All') && (field != 'styles' || value != 'All')) {
          filterObject[field + ++c] = createQueryForIndex(field, value);
          searchObject[field] = createQueryForIndexNoDate(value);
          searchHashes.push("".concat(field, ":").concat(value));
        }
      });
      DGS.setLocationHash(searchHashes.join('/'));
      var filterWithNoQueryNoHash = function filterWithNoQueryNoHash() {
          if ($('.searchThroughDate')[0]) {
            textSearch = queryDate === null ? 'text=' + ' AND ' + 'orderDateUtc*' : null;
          } else {
            textSearch = queryDate === null ? 'text=' : null;
          }
        },
        filterWithNoQueryButHash = function filterWithNoQueryButHash() {
          if ($('.searchThroughDate')[0]) {
            textSearch = queryDate === null ? "text=".concat(Object.keys(filterObject).map(function (f) {
              return filterObject[f];
            }).join(' AND '), " AND ") + 'orderDateUtc*' : null;
          } else {
            textSearch = queryDate === null ? "text=".concat(Object.keys(filterObject).map(function (f) {
              return filterObject[f];
            }).join(' AND ')) : null;
          }
        },
        filterWithQueryNoHash = function filterWithQueryNoHash() {
          if ($('.searchThroughDate')[0]) {
            textSearch = queryDate === null ? "text=".concat(queryString.trim(), "*") + ' AND ' + 'orderDateUtc*' : null;
          } else {
            textSearch = queryDate === null ? "text=".concat(queryString.trim(), "*") : null;
          }
        },
        filterWithQueryAndHash = function filterWithQueryAndHash() {
          if ($('.searchThroughDate')[0]) {
            textSearch = queryDate === null ? "text=".concat(queryString.trim(), "*") + " AND ".concat(Object.keys(filterObject).map(function (f) {
              return filterObject[f];
            }).join(' AND '), " AND ") + 'orderDateUtc*' : null;
          } else {
            textSearch = queryDate === null ? "text=".concat(queryString.trim(), "*") + " AND ".concat(Object.keys(filterObject).map(function (f) {
              return filterObject[f];
            }).join(' AND ')) : null;
          }
        },
        filterWithNoQueryNoHashInst = function filterWithNoQueryNoHashInst() {
          if ($('.checkboxChecked')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, config.endpoint, fromDate, toDate, {}, 'and', 'text=' + "isWarrantyExpiring eq '1' OR isWarrantyExpiring eq '2'");
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, config.endpoint, fromDate, toDate, {}, 'and', 'parameter=');
          }
        },
        filterWithNoQueryButHashInst = function filterWithNoQueryButHashInst() {
          if ($('.checkboxChecked')[0]) {
            if ($('.reset-all')[0]) {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, config.endpoint, fromDate, toDate, {}, 'and', 'text=' + "isWarrantyExpiring eq '1' OR isWarrantyExpiring eq '2'");
            } else {
              DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, config.endpoint, fromDate, toDate, searchObject, 'and', 'text=' + "isWarrantyExpiring eq '1' OR isWarrantyExpiring eq '2'");
            }
          } else if ($('.reset-all')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, config.endpoint, fromDate, toDate, {}, 'and', 'parameter=');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, config.endpoint, fromDate, toDate, searchObject);
          }
        },
        filterWithQueryNoHashInst = function filterWithQueryNoHashInst() {
          if ($('.checkboxChecked')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, config.endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*") + ' AND ' + '(isWarrantyExpiring eq \'1\' OR isWarrantyExpiring eq \'2\')');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, config.endpoint, fromDate, toDate, {}, 'and', "text=".concat(queryString.trim(), "*"));
          }
        },
        filterWithQueryAndHashInst = function filterWithQueryAndHashInst() {
          if ($('.checkboxChecked')[0]) {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, config.endpoint, fromDate, toDate, searchObject, 'and', "text=".concat(queryString.trim(), "*") + ' AND ' + '(isWarrantyExpiring eq \'1\' OR isWarrantyExpiring eq \'2\')');
          } else {
            DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY_NO_DATE_RANGE, config.endpoint, fromDate, toDate, searchObject, 'and', "text=".concat(queryString.trim(), "*"));
          }
        };
      if (window.location.href.indexOf('instrument-history') > -1) {
        if (queryString == '') {
          searchHashes == '' ? filterWithNoQueryNoHashInst() : filterWithNoQueryButHashInst();
        } else {
          searchHashes == '' ? filterWithQueryNoHashInst() : filterWithQueryAndHashInst();
        }
      } else if ($this.hasClass('product-orders') || $this.hasClass('service-orders') || $this.hasClass('warranty-status')) {
        if (queryString == '') {
          searchHashes == '' ? filterWithNoQueryNoHash() : filterWithNoQueryButHash();
        } else {
          searchHashes == '' ? filterWithQueryNoHash() : filterWithQueryAndHash();
        }
        if (queryDate) {
          DGS.setLocationHash("date:".concat(moment(queryDate).format('YYYYMMDD'), "-").concat(moment(queryDate).format('YYYYMMDD')));
        } else {
          DGS.setLocationHash(queryString);
        }
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, config.endpoint, fromDate, toDate, {}, 'or', textSearch);
      } else {
        DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_SEARCH_QUERY_READY, config.endpoint, queryDate, queryDate, {}, 'and', "text=".concat(Object.keys(filterObject).map(function (f) {
          return filterObject[f];
        }).join(' AND ')));
      }
    },
    createQueryForIndex = function createQueryForIndex(field, query) {
      return "".concat(field, ":").concat(query.trim(), "*");
    },
    createQueryForIndexNoDate = function createQueryForIndexNoDate(value) {
      return value;
    };
  DGS.OnLoad.getInstance().register(function () {
    if ($('.data-hierarchy-spot.data-list-search').length == 0) return;
    $('.data-hierarchy-spot.data-list-search').addClass('loading');
    $('.custom-datepicker').removeClass('searchThroughDate');
    DGS.Dictionary.getInstance().getTexts(dictionary, function () {
      var builderConfigHandler = function builderConfigHandler(data, $spot) {
        $spot.append('<script class="basic-query" type="template/text"><div class="data-list-search-spot__label"><span>{0}</span><a href="#" class="help"></a><div class="help-content"><div class="help-content-icon"></div><div class="help-content-text">{1}</div><div class="help-content-button">{2}</div></div></div><div class="data-list-search-spot__query-container"><input name="ordersSimpleSearch" class="data-list-search-spot__query" placeholder="{3}" type="text"><div class="data-list-search-spot__query-help"></div></div><div class="data-list-search-spot__adv-search-toggle-container"><span class="data-list-search-spot__adv-search-toggle">{4}</span></div></script><script class="adv-query-column" type="template/text"><div class="data-list-search-spot__adv-search-column">{0}</div></script><script class="adv-query-column-wide" type="template/text"><div class="data-list-search-spot__adv-search-column-wide">{0}</div></script><script class="adv-query-text-input" type="template/text"><div class="nice-select square-corners data-list-search-spot__adv-search-label device-wrapper-label">{0}</div><div class="device-wrapper"><div class="data-list-search-spot__adv-search-input-container"><input name="{1}" class="data-list-search-spot__adv-search-input field-{2}" placeholder="{3}" type="text"></div><div class="data-list-search-spot__adv-search-btn-container"><a href="#" class="button">Apply</a></div></script><script class="adv-query-datepicker" type="template/text"><div class="data-list-search-spot__adv-search-label order-date-label">{0}</div><div class="data-list-search-spot__adv-search-input-container"><div name="{1}" class="data-list-search-spot__adv-search-input date-list-search-spot--date-picker order-date-label">{0}</div></div></script><script class="adv-query-category-model" type="template/text"><div class="data-list-search-spot__adv-search-select-group" data-endpoint="{0}"><div class="nice-select square-corners data-list-search-spot__adv-search-label device-wrapper-label">{1}</div><div class="device-wrapper"><div class="data-list-search-spot__adv-search-input-container"><select name="{2}" class="data-list-search-spot__adv-search-input field-{3}"></select></div><!--<div class="data-list-search-spot__adv-search-label">{4}</div>--><div class="data-list-search-spot__adv-search-input-container"><select name="{5}" class="data-list-search-spot__adv-search-input field-{6}"></select></div><!--<div class="data-list-search-spot__adv-search-label">{7}</div>--><div class="data-list-search-spot__adv-search-input-container"><select name="{8}" class="data-list-search-spot__adv-search-input field-{9}"></select></div><div class="data-list-search-spot__adv-search-btn-container"><a href="#" class="button">Apply</a></div><div class="cd-cta-reset"> Reset</div></div></div></script><script class="adv-query-cta" type="template/text"></script><script class="disclaimer-text" type="template/text"><div class="disclaimer">{0}</div></script>');
        var basicQueryTemplate = $('.basic-query', $spot).html(),
          advQueryColumnTemplate = $('.adv-query-column').html(),
          advQueryColumnTemplateWide = $('.adv-query-column-wide').html(),
          advQueryTextInputTemplate = $('.adv-query-text-input').html(),
          advQueryProductModelStyleTemplate = $('.adv-query-category-model').html(),
          advQueryDatepickerTemplate = $('.adv-query-datepicker').html(),
          disclaimerText = $('.disclaimer-text').html(),
          $clearFix = $('<div class="clearfix"></div>'),
          advQueryCtaTemplate = $('.adv-query-cta').html(),
          config,
          columnStyles = ['one-column', 'two-columns', 'three-columns', 'four-columns'],
          containers = [],
          basicQueryContainer = {
            className: 'data-list-search-spot__simple-search',
            components: null
          },
          advQueryContainer = {
            className: 'data-list-search-spot__adv-search',
            components: null
          };
        if ($spot.hasClass('service-orders')) {
          basicQueryContainer.components = [$(basicQueryTemplate.format(dictionary.B2B.OrderSearchFor, data.helpText, dictionary.B2B.HelpAccept, dictionary.B2B.ServiceOrderSearchPlaceholder, dictionary.B2B.AdvancedSearch))];
          advQueryContainer.components = [$(advQueryColumnTemplate.format(advQueryDatepickerTemplate.format(dictionary.B2B.OrderDateLabel) + advQueryCtaTemplate.format(dictionary.B2B.OrderDateSearch))), $(advQueryColumnTemplateWide.format(disclaimerText.format(dictionary.B2B.DisclaimerServiceOrders))), $clearFix];
          containers.push(basicQueryContainer);
          containers.push(advQueryContainer);
        } else if ($spot.hasClass('product-orders')) {
          basicQueryContainer.components = [$(basicQueryTemplate.format(dictionary.B2B.OrderSearchFor, data.helpText, dictionary.B2B.HelpAccept, dictionary.B2B.ProductOrderSearchPlaceholder, dictionary.B2B.AdvancedSearch))];
          advQueryContainer.components = [$(advQueryColumnTemplate.format(advQueryDatepickerTemplate.format(dictionary.B2B.OrderDateLabel) + advQueryCtaTemplate.format(dictionary.B2B.OrderDateSearch))), $(advQueryColumnTemplateWide.format(disclaimerText.format(dictionary.B2B.DisclaimerProductOrders))), $clearFix];
          containers.push(basicQueryContainer);
          containers.push(advQueryContainer);
        } else if ($spot.hasClass('warranty-status')) {
          basicQueryContainer.components = [$(basicQueryTemplate.format(dictionary.B2B.OrderSearchFor, data.helpText, dictionary.B2B.HelpAccept, dictionary.B2B.WarrantyStatusSearchPlaceholder, dictionary.B2B.AdvancedSearch))];
          advQueryContainer.components = [];
          containers.push(basicQueryContainer);
          containers.push(advQueryContainer);
        }
        $spot.addClass(columnStyles[advQueryContainer.components.length - 2]); // not counting clearfix
        config = {
          mainContainer: $('.component-content', $spot),
          sections: {
            desktop: {
              containers: containers
            }
          }
        };
        return config;
      };
      window.DGS.Components.DataHierarchySpot.getInstance().register('data-list-search', builderConfigHandler, function ($spot, config) {
        $spot.removeClass('loading');

        // replace URL placeholder with Customer ID.
        if (window.sessionStorage.getItem('cid')) {
          config.endpoint = config.endpoint.replace(/\{CustomerID\}/, window.sessionStorage.getItem('cid'));
        }
        var $advSearchToggle = $('.data-list-search-spot__adv-search-toggle', $spot),
          $advSearchContainer = $('.data-list-search-spot__adv-search.outer-container', $spot),
          querySearchFrom = null,
          querySearchTo = null,
          querySearch = DGS.getLocationHash().toLowerCase(),
          basicSearchTerm = function (querySearch) {
            return querySearch.indexOf(':') == -1 ? querySearch : null;
          }(querySearch),
          advSearchFields = function (querySearch) {
            if (querySearch.indexOf(':') > -1) {
              var searchParts = querySearch.split('/'),
                searchObj = {},
                keyValue,
                key,
                value;
              searchParts.forEach(function (searchPart) {
                keyValue = searchPart.split(':');
                key = keyValue[0];
                value = keyValue[1];
                if (!searchObj.hasOwnProperty(key)) {
                  searchObj[key] = [];
                }
                searchObj[key].push(value);
              });
              return searchObj;
            }
            return null;
          }(querySearch),
          blockSearchTemp = false,
          setBlockSearchTemp = function setBlockSearchTemp() {
            blockSearchTemp = true;
            setTimeout(function () {
              blockSearchTemp = false;
            }, 500);
          },
          openAdvSearch = function openAdvSearch() {
            $advSearchToggle.addClass('open');
            $advSearchContainer.addClass('open');
            var position = $('.data-list-search-spot__adv-search.outer-container').position(),
              top = position ? position.top : null;
            if (top != null) {
              // window.scrollTo(0, );
              TweenMax.to(window, 0.3, {
                scrollTo: {
                  x: 0,
                  y: top - 6 * parseFloat(getComputedStyle(document.body).fontSize)
                }
              });
            }
          },
          closeAdvSearch = function closeAdvSearch() {
            $advSearchToggle.removeClass('open');
            $advSearchContainer.removeClass('open');
          };

        // HANDLE URL QUERY DATE SEARCH
        if (advSearchFields) {
          if (advSearchFields.hasOwnProperty('date')) {
            var dateRange = advSearchFields.date[0].split('-');
            querySearchFrom = dateRange[0];
            querySearchTo = dateRange[1];
          }
        }
        // TOGGLE ADV / SIMPLE SEARCH
        $advSearchToggle.click(function () {
          var $this = $(this);
          if (!$this.hasClass('open')) {
            openAdvSearch();
          } else {
            closeAdvSearch();
          }
        });

        // BASIC SEARCH QUERY
        $('.data-list-search-spot__query', $spot).keydown(function (e) {
          if (blockSearchTemp) return;
          if (e.keyCode === 13) {
            e.preventDefault();
            setBlockSearchTemp();
            runBasicQuery($spot, config);
          }
        });

        // ADV SEARCH
        $('.data-list-search-spot__adv-search-input', $spot).keyup(function (e) {
          if (blockSearchTemp) return;
          if (e.keyCode === 13) {
            setBlockSearchTemp();
            runAdvancedQuery($spot, config.endpoint);
          }
        });
        $('.data-list-search-spot__adv-search-btn-container a', $spot).click(function (event) {
          if (blockSearchTemp) return;
          event.preventDefault();
          setBlockSearchTemp();
          runAdvancedQuery($spot, config.endpoint);
        });
        $('.reset-filters').click(function (event) {
          if (blockSearchTemp) return;
          event.preventDefault();
          setBlockSearchTemp();
          runAdvancedQuery($spot, config.endpoint);
          setFilters();
        });
        $('.search-by-checkbox input').click(function (event) {
          if (blockSearchTemp) return;
          setBlockSearchTemp();
          runAdvancedQuery($spot, config.endpoint);
        });

        // HANDLE URL QUERY STRING SEARCH
        if (basicSearchTerm) {
          $('.data-list-search-spot__query', $spot).val(basicSearchTerm);
          DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_INITIAL_BUILD_QUERY, $spot, config.endpoint);
        } else if (advSearchFields) {
          openAdvSearch();
          $('*[class*=field]').each(function () {
            var $input = $(this);
            var classes = $input.attr('class').toLowerCase().split(' '),
              value;
            classes.forEach(function (className) {
              if (className.indexOf('field-') == 0) {
                className = className.substr(6);
                if (advSearchFields.hasOwnProperty(className)) {
                  value = advSearchFields[className].shift();
                  if (advSearchFields[className].length == 0) {
                    delete advSearchFields[className];
                  }
                  $input.val(value);
                }
              }
            });
          });
          if (advSearchFields.hasOwnProperty('date')) {
            var dateRange = advSearchFields.date[0].split('-');
            querySearchFrom = dateRange[0];
            querySearchTo = dateRange[1];
          }
          DGS.Event.getInstance().trigger(DGS.DataListSpotConfig.Event.DATA_REQUEST_INITIAL_BUILD_ADV_QUERY, $spot, config.endpoint);
        }

        // INIT DATE PICKER
        var $searchDatepicker = $('.date-list-search-spot--date-picker', $spot);
        if ($searchDatepicker.length) {
          if ($spot.hasClass(datepickerNoRangeStyleVariation)) {
            $searchDatepicker.val(dictionary.B2B.EmptyDatepickerText);
            $searchDatepicker.addClass('disabled');
            var $clearDatepicker = $("<span class='clear-datepicker'>X</span>").insertAfter($searchDatepicker);
            $searchDatepicker.on('click', function () {
              if (!$(this).parent().hasClass('custom-datepicker')) {
                // If there is not a datepicker already initialized
                initializeDatePicker($spot);
                $clearDatepicker.addClass('show');
                $searchDatepicker.removeClass('disabled');
              }
            });

            // Adding the clear button
            $clearDatepicker.on('click', function () {
              $searchDatepicker.insertBefore($(this), null);
              $searchDatepicker.val(dictionary.B2B.EmptyDatepickerText);
              $searchDatepicker.addClass('disabled');
              $(this).siblings('.custom-datepicker').remove();
              $searchDatepicker.customDatePickerClear();
              $(this).removeClass('show');
            });
          } else {
            initializeDatePicker($spot);
          }
        }
        function initializeDatePicker($spot) {
          config.shortcuts = config.shortcuts != undefined || config.shortcuts != null ? eval(config.shortcuts) : config.shortcuts;
          $('.date-list-search-spot--date-picker', $spot).customDatePicker({
            shortcuts: config.shortcuts || [{
              label: 'Last 7 days',
              expr: '-7d'
            }, {
              label: 'Last 30 days',
              expr: '-30d'
            }, {
              label: 'Last month',
              expr: '-1mo'
            }],
            initialFrom: querySearchFrom,
            initialTo: querySearchTo,
            expr: config.expr || '-60d',
            dateRangeLimit: config.dateRangeLimit || '60d',
            dateFormat: config.dateFormat ? config.dateFormat.toUpperCase() : 'YYYY-MM-DD',
            customRangeLabel: config.customRangeLabel || 'Custom range',
            fromDateLabel: config.fromDateLabel || 'FROM',
            toDateLabel: config.toDateLabel || 'TO',
            applyLabel: config.applyLabel || 'Apply',
            cancelLabel: config.cancelLabel || 'Cancel',
            negativeRangeLabel: config.negativeRangeLabel || 'FROM must be before TO',
            invalidRangeLabel: config.invalidRangeLabel || 'FROM and TO cannot be more than 60 days apart'
          });
          if ($spot.hasClass('date-only')) {
            $('.date-list-search-spot--date-picker', $spot).change(function () {
              runAdvancedQuery($spot, config.endpoint);
            });
          }
          if ($spot.hasClass('search-spot-redesign')) {
            $('.date-list-search-spot--date-picker', $spot).change(function () {
              runAdvancedQuery($spot, config.endpoint);
            });
          }
        }

        // ADD HELP INTERACTION
        $('.help', $spot).each(function () {
          var $this = $(this),
            $content = $('.help-content', $this.parent()),
            $overlay = $('.help-content-overlay', $this.parent()),
            $contentButton = $('.help-content-button', $content);
          $.merge($this, $contentButton).click(function () {
            if (!$overlay.length) {
              $overlay = $('<div class="help-content-overlay"></div>');
              $content.before($overlay);
            }
            if (!$content.is(':visible')) {
              $overlay.show();
              $content.show();
              TweenMax.fromTo($content, 0.3, {
                alpha: 0
              }, {
                alpha: 1,
                ease: Power2.easeIn
              });
            } else {
              TweenMax.fromTo($content, 0.3, {
                alpha: 1
              }, {
                alpha: 0,
                ease: Power2.easeIn,
                onComplete: function onComplete() {
                  $content.hide();
                  $overlay.hide();
                }
              });
            }
          });
        });
      });
    });
  });
})(jQuery, window.DGS, window.moment);